module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\n/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\nspan {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 5px;\n  padding: 0 6px;\n  font-size: 10px;\n  color: #ffffff;\n  border-radius: 7px;\n  background-color: #2b98f0;\n  height: 14px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-label/ui-label.less
// module id = 1112
// module chunks = 3